const pictureQuestion1 = require('./img/mot1.png');
const pictureQuestion2 = require('./img/mot2.png');
const pictureQuestion3 = require('./img/mot3.png');
const pictureQuestion4 = require('./img/mot4.png');
const pictureClose = require('./img/xmark-solid.svg');

const GameState = {
	uninitialized: -1,
	playing: 0,
	done: 1,
	results: 2,
};

// TODO: Update font-size based on layout
document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	currentQuestionIndex: 0,
	questions: [
		{
			picture: pictureQuestion1,
			solution: 'douleur',
			tip: '« À chaque fois que je marche, je ressens comme une épine dans mon genou. »',
			ref: '1. SFR,2019. Comment se manifeste l\'arthrose ? [en ligne] https://public.larhumatologie.fr/grandes-maladies/arthrose/comment-se-manifeste-larthrose - consulté le 02.09.2022',
		}, {
			picture: pictureQuestion2,
			solution: 'raideur',
			tip: '« Je suis bloqué(e), je ne parviens pas à m’asseoir. »',
			ref: '1. SFR,2019. Comment se manifeste l\'arthrose ? [en ligne] https://public.larhumatologie.fr/grandes-maladies/arthrose/comment-se-manifeste-larthrose - consulté le 02.09.2022',
		}, {
			picture: pictureQuestion3,
			solution: 'gonflement',
			tip: '« Mon genou semble avoir doublé de volume. »',
			ref: '1. SFR,2019. Comment se manifeste l\'arthrose ? [en ligne] https://public.larhumatologie.fr/grandes-maladies/arthrose/comment-se-manifeste-larthrose - consulté le 02.09.2022',
		}, {
			picture: pictureQuestion4,
			solution: 'déformation',
			acceptedSolution: ['deformation'],
			tip: '« Je ne reconnais plus mes genoux. »',
			ref: '1. SFR,2019. Comment se manifeste l\'arthrose ? [en ligne] https://public.larhumatologie.fr/grandes-maladies/arthrose/comment-se-manifeste-larthrose - consulté le 02.09.2022',
		},
	],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this._renderCurrentQuestion();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				document.getElementById('state-results').classList.remove('hidden')
				break;
		}
	},
	showTips() {
		if (document.getElementById('tips-content')) return;

		const currentQuestion = this.questions[this.currentQuestionIndex];
		const tipsButton = document.getElementById('show-tips');

		const tipDiv = document.createElement("div");
		tipDiv.innerHTML = `<p>${currentQuestion.tip}</p><img src="${pictureClose}" onclick="Game.closeTips()" />`;
		tipDiv.setAttribute("id", "tips-content");

		tipsButton.appendChild(tipDiv);
	},
	closeTips() {
		const tipsContent = document.getElementById('tips-content');
		const tipsButton = document.getElementById('show-tips');

		tipsButton.removeChild(tipsContent);
	},
	answer() {
		const currentQuestion = this.questions[this.currentQuestionIndex];

		// Remove previous error tooltip if still here
		const errorMsg = document.getElementById('error-message');
		if (errorMsg) {
			document.getElementById('input-area').removeChild(errorMsg);
		}

		// Get answer
		const inputsHtml = document.getElementsByClassName('letter-input');
		const answer = Array.from(inputsHtml).map(input => input.value).join("").toLowerCase();

		const possibleAnswers = (currentQuestion.acceptedSolution || []).concat(currentQuestion.solution);
		// Check
		if (possibleAnswers.includes(answer)) {
			/**
			 * Add class success to toggle everything with css instead of complex JS
			 * - Display next button instead of confirm
			 * - Display ref
			 * - Disable input and set blue background
			 * - Display success tooltip
			 */
			const successDiv = document.createElement("div");
			successDiv.innerHTML = `<strong>Exact!</strong>`;
			successDiv.setAttribute("id", "success-message");
			document.getElementById('ref-number').appendChild(successDiv);

			document.getElementById('state-playing').classList.add('success');
		} else {
			// Show error message for 5 second
			const errorDiv = document.createElement('div')
			errorDiv.innerHTML = "Oups ! Ce n'est pas le bon mot.";
			errorDiv.setAttribute("id", "error-message");
			document.getElementById('input-area').appendChild(errorDiv);
			setTimeout(() => {
				document.getElementById('input-area').removeChild(errorDiv);
			}, 5000);
		}
	},
	_renderCurrentQuestion() {
		const currentQuestion = this.questions[this.currentQuestionIndex];

		// Set background
		document.getElementById('state-playing').style.backgroundImage = `url(${currentQuestion.picture})`;

		// Add answer squares
		// input-area
		const inputArea = document.getElementById('input-area');
		const inputs = [];
		for (let i = 0; i < currentQuestion.solution.length; i++) {
			inputs.push(`<input class="letter-input" name="letter-${i}" data-index="${i}" maxlength="1" />`);
		}
		inputs.push(`<sup id="ref-number">1</sup>`);
		inputArea.innerHTML = inputs.join('');
		this._handleEventForLetterBoxes(inputArea);

		document.getElementById('answer-length').innerHTML = `(${currentQuestion.solution.length} lettres)`;

		document.getElementById('reference').innerHTML = currentQuestion.ref;
	},
	_handleEventForLetterBoxes(inputArea) {
		const inputsHtml = document.getElementsByClassName('letter-input');
		inputArea.addEventListener('input', (event) => {
			const { index } = event.target.dataset;
			if (event.inputType === 'deleteContentBackward') {
				return;
			}
			inputsHtml[+index + 1]?.focus();
			inputsHtml[+index + 1]?.setSelectionRange(0, 1);
		});
		inputArea.addEventListener('keydown', (event) => {
			if (event.key === 'ArrowRight') {
				event.preventDefault();
				const { index } = event.target.dataset;
				const selectedInput = inputsHtml[+index + 1];
				if (!selectedInput) return;
				selectedInput.focus();
				selectedInput.setSelectionRange(0, 1)
			}
			if (event.key === 'ArrowLeft') {
				event.preventDefault();
				const { index } = event.target.dataset;
				const selectedInput = inputsHtml[+index - 1];
				if (!selectedInput) return;
				selectedInput.focus();
				selectedInput.setSelectionRange(0, 1)
			}
		});
	},
	restart() {
		this.currentQuestionIndex = 0;
		this.state = GameState.playing;
		this.render();
	},
	next() {
		document.getElementById('state-playing').classList.remove('success');
		this.currentQuestionIndex += 1;
		if (this.currentQuestionIndex === this.questions.length) {
			this.state = GameState.done;
		}
		this.render();
	},
	seeResults() {
		this.state = GameState.results;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();
addEventListener('resize', document.computeSizes);
